import * as React from 'react';
import { useSelector } from 'react-redux';

import { IDailyRentOfferForMobileSite } from '../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { selectListingBreadcrumbs } from '../../../common/selectors/listingOffers';
import { selectQueryStringWithQMark } from '../../../common/selectors/queryString';
import { selectResultsJsonQuery } from '../../../common/selectors/results';
import { Breadcrumbs } from '../../components';
import { trackBreadcrumbsClick } from '../../tracking';

interface IBreadcrumbsContainerProps {
  offers: IDailyRentOfferForMobileSite[];
}

export function BreadcrumbsContainer({ offers }: IBreadcrumbsContainerProps) {
  const breadcrumbs = useSelector(selectListingBreadcrumbs);
  const jsonQuery = useSelector(selectResultsJsonQuery);
  const queryString = useSelector(selectQueryStringWithQMark);

  const handleBreadcrumbClick = React.useCallback(() => {
    trackBreadcrumbsClick({ offers, jsonQuery, queryString });
  }, [offers, jsonQuery, queryString]);

  if (!breadcrumbs?.length) {
    return null;
  }

  return <Breadcrumbs breadcrumbs={breadcrumbs} handleBreadcrumbsClick={handleBreadcrumbClick} />;
}
